import { Swiper } from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

(function () {
  const carousels = document.querySelectorAll(".custom-block-carousel .swiper");

  const getSliderOptions = (carousel) => {
    switch (carousel.dataset.jsSliderType) {
      case "slots": {
        return {
          slidesPerView: 1,
          spaceBetween: 12,
          freeMode: true,
          loop: false,
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          },
        };
      }
      default:
        const baseBreakpoints = {
          640: {
            slidesPerView: 4,
          },
        };

        const fullBreakpoints = {
          ...baseBreakpoints,
          1024: {
            slidesPerView: 6,
          },
        };

        const isContentHasSidebar = carousel.closest(
          ".page-content-body--has-sidebar"
        );

        return {
          slidesPerView: 2,
          spaceBetween: 12,
          freeMode: true,
          loop: false,
          breakpoints: isContentHasSidebar ? baseBreakpoints : fullBreakpoints,
        };
    }
  };

  for (const carousel of carousels) {
    const scrollbar = carousel.querySelector(".swiper-scrollbar");
    const prev = carousel.querySelector(".swiper-prev");
    const next = carousel.querySelector(".swiper-next");

    const options = getSliderOptions(carousel);

    new Swiper(carousel, {
      ...options,
      modules: [Navigation, Scrollbar],
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      scrollbar: {
        el: scrollbar,
      },
    });
  }
})();
